export default "https://cdn.questicon.mathletics.com/assets/images/silver-bar-3bfbbcca68c297e211a3d9c5edccc76a.png";